"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePTTMutation = void 0;

var _reactQuery = require("react-query");

var _utils = require("../utils/utils");

var _excluded = ["multipart"];

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Wrapper around react-query's useMutation
 * @deprecated - use react-query useMutation() instead.
 */
var usePTTMutation = function usePTTMutation(url, options, fetchOptions) {
  return (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (body) {
      var data = options !== null && options !== void 0 && options.multipart ? valuesToFormData(body) : JSON.stringify(body);
      var response = yield (0, _utils.pttFetch)(url, _objectSpread({
        method: 'post',
        headers: _objectSpread(_objectSpread({}, !(options !== null && options !== void 0 && options.multipart) && {
          'Content-Type': 'application/json'
        }), fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.headers),
        body: data
      }, fetchOptions));
      return response.data;
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), getOptionsWitoutMultipart(options));
};

exports.usePTTMutation = usePTTMutation;

function getOptionsWitoutMultipart(options) {
  if (!options) {
    return options;
  }

  var multipart = options.multipart,
      rest = _objectWithoutProperties(options, _excluded);

  return rest;
}

function valuesToFormData(values) {
  var result = new FormData();

  for (var key in values) {
    var value = _typeof(values[key]) === 'object' && !(values[key] instanceof File) ? JSON.stringify(values[key]) : values[key];
    result.append(key, value);
  }

  return result;
}